import { PhoneErrorMap, getPhoneErrorsObjectMap } from './phone.errors';
import { SsnErrorMap, getSsnErrorsObjectMap } from './ssn.errors';
import { EmailErrorMap, getEmailErrorsObjectMap } from './email.errors';
import { GeneralErrorMap, getGeneralErrorsObjectMap } from './general.errors';
import { PasswordErrorMap, getPasswordErrorsObjectMap } from './password.errors';
import { AddressErrorMap, getAddressErrorsObjectMap } from './address.errors';
import { AuthErrorMap, getAuthErrorsObjectMap } from './auth.errors';
import { KycErrorMap, getKycErrorsObjectMap } from './kyc.errors';
import { PersonalErrorMap, getPersonalErrorsObjectMap } from './personal.errors';
import { BusinessErrorMap, getBusinessErrorsObjectMap } from './business.errors';
import {
  getVerificationCenterErrorsObjectMap,
  VerificationCenterErrorMap,
} from './verificationCenter.errors';
import type { IErrorHandling } from '@Types/types.ts';

export const ErrorsMap = {
  ...AuthErrorMap,
  ...PhoneErrorMap,
  ...SsnErrorMap,
  ...EmailErrorMap,
  ...GeneralErrorMap,
  ...PasswordErrorMap,
  ...AddressErrorMap,
  ...KycErrorMap,
  ...PersonalErrorMap,
  ...BusinessErrorMap,
  ...VerificationCenterErrorMap,
};

export const ErrorsMapList = Object.values(ErrorsMap);

export const findMappedError = (errorCode: number) =>
  ErrorsMapList.find((error) => error.errorCode === errorCode);

export const getCombinedErrorsObjectMap = () =>
  new Map<number, IErrorHandling>([
    ...getPhoneErrorsObjectMap(),
    ...getSsnErrorsObjectMap(),
    ...getEmailErrorsObjectMap(),
    ...getGeneralErrorsObjectMap(),
    ...getPasswordErrorsObjectMap(),
    ...getAddressErrorsObjectMap(),
    ...getAuthErrorsObjectMap(),
    ...getKycErrorsObjectMap(),
    ...getPersonalErrorsObjectMap(),
    ...getBusinessErrorsObjectMap(),
    ...getVerificationCenterErrorsObjectMap(),
  ]);
